const defaultRoute = "/";

export default defaultRoute;
